/* ========================== */
/* ========= import ========= */
/* ========================== */

/* ====== React ====== */
import React from 'react'

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import check from '05Images/check.svg'
import arrowLeft from '05Images/arrowLeft.svg'
import temporarilyKeep from '05Images/temporarilyKeep.svg'
import search from '05Images/search.svg'
import Xmark from '05Images/Xmark.svg'
import pencil from '05Images/pencil.svg'
import sendWhite from '05Images/sendWhite.svg'
import sendBlue from '05Images/sendBlue.svg'
import arrowRight from '05Images/arrowRight.svg'
import newRegisterPlus from '05Images/newRegisterPlus.svg'
import allRegister from '05Images/allRegister.svg'
import output from '05Images/output.svg'
import csv from '05Images/csv.svg'
import plus from '05Images/plus.svg'
import excel from '05Images/excel.svg'
import update from '05Images/update.svg'
import orderArrow from '05Images/orderArrow.svg'
import trashBox from '05Images/trashBox.svg'
import cancel from '05Images/cancel.svg'
import crossline from '05Images/crossline.svg'
import sendMail from '05Images/sendMail.svg'
import clip from '05Images/clip.svg'
import download from '05Images/download.svg'
import copyRegister from '05Images/copyRegister.svg'
import insertRow from '05Images/insertRow.svg'
import backArrow from '05Images/backArrow.svg';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { AUTHORITY_STORAGE, screenMaster } from '03CommonApiParts/CodeDefinition';
import { CFArrayFount } from '03CommonApiParts/CommonFunction';
import { useLocation } from 'react-router-dom';

/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
const SlabelBalloon = styled.label`//ツールチップ
    text-align:center;
    height: fit-content;
    display: none;
    position: absolute;
    border-radius: 3px;
    z-index: 50;
    bottom: 33px;
    ${props => props.lockLeft ? 'left: -10px;' : 'right: -10px;'};
    /* top:  ${props => props.baloonTopPosition ? props.baloonTopPosition : ' -20px'}; */
    background-color: black;
    opacity:0.7;
    color: #ffffff;
    padding: 2px 8px;
    width: ${props => props.width};
    max-width:200px;
    /* transform:translate(-50%,-50%); */
    overflow-wrap:break-word;
    /* white-space: ${props => props.width ? 'normal' : 'nowrap'}; */
    :after {
        position: absolute;
        top: ${props => props.triangleTopPosition ? props.triangleTopPosition : ' 100%'};
        /* left: ${props => props.trianglePosition ? props.trianglePosition : ' 25%'}; */
        ${props => props.lockLeft ? 'left: 15px;' : 'right: 15px;'}
        border: 5px solid transparent;
        border-top: 10px solid black; 
      content: " ";
    }
`;
/* ------ ボタンのベース ------*/
const SButtonBaseOutline = styled.button`//ベース枠
    justify-content: center;
    background-color: ${assets().color.white};
    border: solid 1px #2e94b9;
    border-radius: 3px;
    color: ${assets().color.blue};
    display: flex;
    font-weight:bold;
    position: relative;
    padding:0px;
    align-items: center;
    pointer-events: ${(props) => props.pointerEvents};
    opacity: ${(props) => props.pointerEvents === 'none' ? 0.3 : 1};
    white-space:nowrap;
    &:hover{
        background-color: ${assets().color.whiteHover};
        cursor: pointer;
    }
    &:hover label{
        display: block;
    }
    &:active{
        top:1px;
        left:1px;
        box-shadow: none;
        background-color:${assets().color.blue};
        color:${assets().color.white};
    }
    &:disabled{
        color:${assets().color.disabled};
        background-color:${assets().color.white};
        border:1px solid #BDBDBD;
    }
`;

const SButtonBaseRedOutline = styled(SButtonBaseOutline)`//ベース枠
    border: solid 1px #D45B5B;
    color: ${assets().color.red};
    &:active{
        background-color: ${props =>props.disabled ? null : assets().color.red};
    }
`;

const SButtonBaseOutlineFormat = styled(SButtonBaseOutline)`

`;



const SButtonBlue = styled(SButtonBaseOutline)`
    color: ${assets().color.white};
    background-color: ${assets().color.blue};
    &:hover{
        background-color: ${assets().color.blueHover};
        cursor: pointer;
    }
    &:active{
        background-color:${assets().color.white};
        color:${assets().color.blue};
    };
    &:disabled{
        color:${assets().color.disabled};
        background-color:${assets().color.white};
        border:1px solid #BDBDBD;
    }
`;
const SsvgIcon = styled.svg` //SVG用
    padding-right:10px;
`;
const SsvgNextIcon = styled.svg` //次へボタンのSVG用
    padding-left:10px;
`;
const SsvgIconButton = styled.svg` //SVG用
    cursor: pointer;
    color:${props => props.color};
    pointer-events:${props => props.disabled ? 'none': ''};
`;


/* 　使い方
    <ButtonAddRowA
        onClick={onClickButton}  />
 */


/* ============================ */
/* ========= 共通パーツ ========= */
/* ============================ */

/* ====== ブルーボタン ====== */
export const ButtonBase = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, icon, type, onClick, disabled, pointerEvents, onChange, textColor, width } = props;
    return (
        <>
            <SButtonBlue
                style={{ fontSize: assets().size.baseText, height: assets().size.buttonHeight, width: assets().size.buttonWidth }}
                textColor={textColor}
                width={width}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='buttonStyle'
            >{icon}{text}</SButtonBlue>
        </>
    );
};
export const IconButtonBase = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, type, onClick, disabled, pointerEvents, onChange, textColor, baloonPosition, trianglePosition, xlinkHref, lockLeft } = props;
    return (
        <>
            <SButtonBlue
                style={{ fontSize: assets().size.baseText, height: assets().size.iconButtonHeight, width: assets().size.iconButtonWidth }}
                textColor={textColor}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='iconButtonStyle'
            >
                <SsvgIconButton className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                    <use xlinkHref={xlinkHref}></use>
                </SsvgIconButton>
                <SlabelBalloon className='fontsizeButtonTooltipText' style={{ fontSize: assets().size.fontsizeButtonTooltipText }} baloonPosition={baloonPosition} trianglePosition={trianglePosition} lockLeft={lockLeft}>
                    {text.split('\n').map((item, index) => (
                        <p key={`${item}${index}`} style={{ margin: '0px', textAlign: 'left' }}>{item}</p>
                    ))}
                </SlabelBalloon>
                {/* {text} */}
            </SButtonBlue>
        </>
    );
};
/* ====== ブルーアウトラインボタン ====== */
export const ButtonBlueOutline = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, icon, type, onClick, disabled, pointerEvents, onChange, textColor, width } = props;
    return (
        <>
            <SButtonBaseOutline
                style={{ fontSize: assets().size.baseText, height: assets().size.buttonHeight, width: width ? width : assets().size.buttonWidth }}
                textColor={textColor}
                width={width}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='buttonStyle'
            >{icon}{text}</SButtonBaseOutline>
        </>
    );
};
/* ====== レッドアウトラインボタン ====== */
export const ButtonRedOutline = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, icon, type, onClick, disabled, pointerEvents, onChange, textColor, width } = props;
    return (
        <>
            <SButtonBaseRedOutline
                style={{ fontSize: assets().size.baseText, height: assets().size.buttonHeight, width: width ? width : assets().size.buttonWidth }}
                textColor={textColor}
                width={width}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='buttonStyle'
            >{icon}{text}</SButtonBaseRedOutline>
        </>
    );
};

export const IconOutlineButtonBase = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, type, onClick, disabled, pointerEvents, onChange, textColor, xlinkHref, baloonPosition, trianglePosition, baloonTopPosition, triangleTopPosition, lockLeft } = props;
    return (
        <>
            <SButtonBaseOutline
                style={{ fontSize: assets().size.baseText, height: assets().size.iconButtonHeight, width: assets().size.iconButtonWidth }}
                textColor={textColor}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='iconButtonStyle'
            >
                <SsvgIconButton className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                    <use xlinkHref={xlinkHref}></use>
                </SsvgIconButton>
                <SlabelBalloon className='fontsizeButtonTooltipText' style={{ fontSize: assets().size.fontsizeButtonTooltipText }} baloonPosition={baloonPosition} trianglePosition={trianglePosition} baloonTopPosition={baloonTopPosition} triangleTopPosition={triangleTopPosition} lockLeft={lockLeft}>
                    {text.split('\n').map((item, index) => (
                        <p key={`${item}${index}`} style={{ margin: '0px', textAlign: 'left' }}>{item}</p>
                    ))}
                </SlabelBalloon>
                {/* {text} */}
            </SButtonBaseOutline>
        </>
    );
};
export const IconOutlineButtonRed = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, type, onClick, disabled, pointerEvents, onChange, textColor, xlinkHref, baloonPosition, trianglePosition, baloonTopPosition, triangleTopPosition, lockLeft } = props;
    return (
        <>
            <SButtonBaseRedOutline
                style={{ fontSize: assets().size.baseText, height: assets().size.iconButtonHeight, width: assets().size.iconButtonWidth }}
                textColor={textColor}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='buttonStyle'
            >
                <SsvgIconButton className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                    <use xlinkHref={xlinkHref}></use>
                </SsvgIconButton>
                <SlabelBalloon className='fontsizeButtonTooltipText' style={{ fontSize: assets().size.fontsizeButtonTooltipText }} baloonPosition={baloonPosition} trianglePosition={trianglePosition} baloonTopPosition={baloonTopPosition} triangleTopPosition={triangleTopPosition} lockLeft={lockLeft}>
                    {text.split('\n').map((item, index) => (
                        <p key={`${item}${index}`} style={{ margin: '0px', textAlign: 'left' }}>{item}</p>
                    ))}
                </SlabelBalloon>
                {/* {text} */}
            </SButtonBaseRedOutline>
        </>
    );
};



/* ====== フォーマット用ボタン ====== */
export const ButtonBlueOutlineFormat = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, icon, type, onClick, disabled, pointerEvents, onChange, textColor, width, } = props;
    return (
        <>
            <SButtonBaseOutlineFormat
                style={{ fontSize: assets().size.baseText, height: assets().size.formatButtonHeight, width: assets().size.formatButtonWidth }}
                textColor={textColor}
                width={width}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='FormatButtonStyle'
            >{icon}{text}</SButtonBaseOutlineFormat>
        </>
    );
};


/* ====== 次へボタン用スタイル ====== */
const ButtonBaseNext = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { text, icon, type, onClick, disabled, pointerEvents, onChange, textColor, width } = props;
    return (
        <>
            <SButtonBlue
                textColor={textColor}
                width={width}
                pointerEvents={pointerEvents}
                type={type}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                className='buttonStyle'
                style={{ fontSize: assets().size.baseText, height: assets().size.buttonHeight, width: assets().size.buttonWidth }}
            >{text}{icon}</SButtonBlue>
        </>
    );
};

/* ====== 更新ボタン ====== */
export const ButtonUpdate = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <ButtonBase
            text='更 新'
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${check}#check`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};
/* ====== 表示順更新ボタン ====== */
export const ButtonUpdateOrder = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <ButtonBase
            text='表示順更新'
            type='button'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${check}#check`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};
/* ====== 登録ボタン ====== */
export const ButtonRegister = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { disabled } = props;
    return (
        <ButtonBase
            text='登 録'
            type='submit'
            // onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${check}#check`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== csvボタン ====== */
export const ButtonCsv = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    return (
        <IconOutlineButtonBase
            text='csv出力'
            type='button'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${csv}#csv`}
            lockLeft={lockLeft}
        />
    )
};
/* ====== 確認ボタン ====== */
export const ButtonConfirm = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { disabled } = props;
    return (
        <ButtonBase
            text='確 認'
            type='submit'
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${arrowRight}#arrowRight`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== 戻るボタン ====== */
export const ButtonBack = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='戻　る'
            type='button'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${arrowLeft}#arrowLeft`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== コメント一時保存ボタン ====== */
export const ButtonKeepComment = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='コメント保存'
            type='button'
            onClick={onClick}
            disabled={disabled} />
    )
};

/* ====== 一時保存ボタン ====== */
export const ButtonKeep = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='一時保存'
            type='button'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${temporarilyKeep}#temporarilyKeep`}></use>
                    </SsvgIcon>

                </>
            } />
    )
};

/* ====== 検索ボタン(type:submit) ====== */
export const ButtonSearch = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    return (
        <IconButtonBase
            text='検索'
            type='submit'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${search}#search`}
            lockLeft={lockLeft}
        />
    )
};
/* ====== 検索ボタン(type:button) ====== */
export const ButtonSearchNonSubmit = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    return (
        <IconButtonBase
            text='検索'
            type='button'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${search}#search`}
            lockLeft={lockLeft}
        />
    )
};
/* ====== 検索ボタン ====== */
export const ButtonWhiteBlue = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled, text, type } = props;
    return (
        <ButtonBlueOutline
            text={text}
            style={style}
            type={type}
            onClick={onClick}
            disabled={disabled}
        />
    )
};
/* ====== 検索ボタン ====== */
export const ButtonWhiteBlueWide = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled, text, type } = props;
    return (
        <ButtonBlueOutline
            text={text}
            style={style}
            type={type}
            onClick={onClick}
            disabled={disabled}
        // icon={
        //     <>  
        //         <SsvgIcon className='svgStyle' style={{height:assets().size.svgHeight,width:assets().size.svgHeight}}>
        //             <use xlinkHref={`${search}#search`}></use>
        //         </SsvgIcon>

        //     </>
        // } 
        />
    )
};

/* ====== クリアボタン ====== */
export const ButtonClear = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, baloonTopPosition, baloonPosition, trianglePosition, triangleTopPosition, lockLeft } = props;
    return (
        <IconOutlineButtonBase
            text='クリア'
            type='button'
            onClick={onClick}
            disabled={disabled}
            baloonTopPosition={baloonTopPosition}
            baloonPosition={baloonPosition}
            trianglePosition={trianglePosition}
            triangleTopPosition={triangleTopPosition}
            xlinkHref={`${Xmark}#Xmark`}
            lockLeft={lockLeft}
        />
    )
};
/* ====== キャンセルボタン ====== */
export const ButtonCancelLabel = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='キャンセル'
            style={style}
            type='button'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${cancel}#cancel`}></use>
                    </SsvgIcon>

                </>
            } />
    )
};
/* ====== 適用データに戻すボタン ====== */
export const ButtonApplydayReturn = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, baloonTopPosition, baloonPosition, trianglePosition, triangleTopPosition, lockLeft } = props;
    return (
        <IconOutlineButtonBase
            text='適用中データに戻す'
            type='button'
            onClick={onClick}
            disabled={disabled}
            baloonTopPosition={baloonTopPosition}
            baloonPosition={baloonPosition}
            trianglePosition={trianglePosition}
            triangleTopPosition={triangleTopPosition}
            xlinkHref={`${backArrow}#backArrow`}
            lockLeft={lockLeft}
        />
    )
};

/* ====== 問合せボタン ====== */
export const ButtonContact = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBase
            text='問合せ'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${sendBlue}#sendBlue`}></use>
                    </SsvgIcon>

                </>
            } />
    )
};

/* ====== 継続ボタン ====== */
export const ButtonContinuation = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='継　続'
            style={style}
            type='button'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${pencil}#pencil`}></use>
                    </SsvgIcon>

                </>
            } />
    )
};
/* ====== 継続ボタン ====== */
export const ButtonAdd = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled, type } = props;
    return (
        <ButtonBase
            text='追　加'
            style={style}
            type={type}
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${plus}#plus`}></use>
                    </SsvgIcon>

                </>
            } />
    )
};

/* ====== 対応履歴検索ボタン ====== */
export const ButtonHistorySearch = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick } = props;
    return (
        <ButtonBlueOutline
            text='対応履歴検索'
            style={style}
            type='button'
            onClick={onClick}
        // disabled={disabled} 
        />
    )
}
/* ====== 対応履歴検索ボタン ====== */
export const ButtonHistory = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick } = props;
    return (
        <ButtonBlueOutline
            text='履歴'
            style={style}
            type='button'
            onClick={onClick}
        // disabled={disabled} 
        />
    )
}

/* ====== 送信ボタン ====== */
export const ButtonSubmit = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBase
            text='送　信'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${sendWhite}#sendWhite`}></use>
                    </SsvgIcon>

                </>
            } />
    )
}

/* ====== 次へボタン ====== */
export const ButtonNext = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <ButtonBaseNext
            text='次　へ'
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgNextIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${arrowRight}#arrowRight`}></use>
                    </SsvgNextIcon>

                </>
            }
        />
    )
}
/* ====== ダッシュボード検索ボタン ====== */
export const ButtonDashSearch = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBase
            text='検　索'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${search}#search`}></use>
                    </SsvgIcon>


                </>
            }
        />
    )
}
/* ====== ダッシュボード前年比ボタン ====== */
export const ButtonLastYear = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled, width } = props;
    return (
        <ButtonBase
            text='前年比'
            style={style}
            type='button'
            onClick={onClick}
            disabled={disabled}
            width={width}
        />
    )
}

/* ====== ログインボタン ====== */
export const ButtonLogin = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='ログイン'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${arrowLeft}#arrowLeft`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== ダッシュボード手動更新ボタン ====== */
export const ButtonDashUpdate = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBase
            text='手動更新'
            style={style}
            type='button'
            onClick={onClick}
            disabled={disabled}
        />
    )
}


// /* ====== フォーマットボタン ====== */
// export const FormatButton = (props) => {
// /* --------------------------- */
// /* --------- valiables -------- */
// /* --------------------------- */
// const { text, icon, type, onClick, disabled, pointerEvents, onChange, textColor, width} = props;
//     return (
//             <SButtonBaseOutline
//                 text='一括登録用フォーマット出力'
//                 style={{fontSize:assets().size.baseText,height:assets().size.formatButtonHeight,width:assets().size.formatButtonWidth}}
//                 textColor={textColor}
//                 width={width}
//                 pointerEvents={pointerEvents}
//                 type={type}
//                 onClick={onClick}
//                 onChange={onChange}
//                 disabled={disabled}
//                 className='buttonStyle'

//                 />
//     );
// };

/* ====== 新規登録ボタン ====== */
export const ButtonNewRegister = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBase
            text='新規登録'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${check}#check`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};


/* ====== 登録ボタン ====== */
export const IconButtonRegister = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <IconButtonBase
            text='登録'
            type='submit'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${check}#check`}
        />
    )
};


/* ====== 表示順変更ボタン ====== */
export const ButtonOrderChange = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='表示順更新'
            style={style}
            type='button'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${orderArrow}#orderArrow`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};
/* ====== 表示順変更アイコンボタン ====== */
export const IconButtonOrderChange = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    return (
        <IconOutlineButtonBase
            text='表示順変更'
            type='button'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${orderArrow}#orderArrow`}
            lockLeft={lockLeft}
        />
    )
};

/* ====== csv出力ボタン ====== */
export const ButtonCSV = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='csv出力'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${output}#output`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== フォーマットボタン ====== */
export const FormatButton = (props) => {
    /* ---------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    return (
        <IconOutlineButtonBase
            text='一括編集用フォーマット出力'
            baloonPosition={'-120px'}
            trianglePosition={'90%'}
            type='button'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${output}#output`}
            lockLeft={lockLeft}
        />
    )
};
/* ====== 出力ボタン ====== */
export const ButtonOutPut = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBlueOutline
            text='出　力'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${output}#output`}></use>
                    </SsvgIcon>

                </>
            } />
    )
};

/* ====== アイコン出力ボタン ====== */
export const ButtonIconOutput = (props) => {
    /* ---------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    return (
        <IconOutlineButtonBase
            text='出力'
            baloonPosition={'15px'}
            trianglePosition={'20%'}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${output}#output`}
            lockLeft={lockLeft}
        />
    )
};


/* ====== 更新ボタン ====== */
export const ButtonIconUpdate = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <IconButtonBase
            text='更新'
            type='button'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${update}#update`}
        />
    )
};

/* ====== 編集ボタン ====== */
export const ButtonIconEdit = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { disabled, lockLeft } = props;
    return (
        <IconOutlineButtonBase
            text='編集'
            type='submit'
            disabled={disabled}
            xlinkHref={`${pencil}#pencil`}
            lockLeft={lockLeft}
        />
    )
};
/* ====== 閉じるボタン ====== */
export const IconDelete = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const {onClick,disabled } = props;
    return(
                <IconButtonBase
                text='閉じる'
                type='button'
                onClick={onClick}
                disabled={disabled}
                xlinkHref={`${crossline}#crossline`}
            />
    )
}
/* ====== 完了ボタン ====== */
export const ButtonCompletion = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled, type } = props;
    return (
        <ButtonBase
            text='完　了'
            style={style}
            type={type ? type : 'button'}
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${check}#check`}></use>
                    </SsvgIcon>

                </>
            } />
    )
}

/* ====== メール送信ボタン ====== */
export const ButtonSendMail = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBase
            text='送 信'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${sendMail}#sendMail`}></use>
                    </SsvgIcon>

                </>
            } />
    )
}
/* ====== アップロードアイコンボタン ====== */

export const ButtonIconUpload = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const {onClick,disabled, lockLeft } = props;
    return(
        <IconOutlineButtonBase
            text='ファイルをアップロード'
            type='button'
            onClick={onClick}        
            baloonPosition={'15px'}    
            trianglePosition={'5%'}
            disabled={disabled}
            xlinkHref={`${clip}#clip`}
            lockLeft={lockLeft}
        />
    )
}

/* ====== チェックボタン ====== */
export const ButtonIconCheck = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    return (
        <IconButtonBase
            text='全てチェック'
            type='button'
            onClick={onClick}
            disabled={disabled}
            xlinkHref={`${check}#check`}
        />

    )

};


/* ====== 行追加ボタン ====== */
export const ButtonIconInsertRow = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props;
    return (
        <ButtonBase
            text='行追加'
            style={style}
            type='button'
            onClick={onClick}
            disabled={disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${insertRow}#insertRow`}></use>
                    </SsvgIcon>

                </>
            } />
    )
}

/* ============================ */
/* ====== 制御対象のボタン ====== */
/* ============================ */

const checkAuthority = (location,id) =>{
    let disabled = false;
    /* AUTHORITY_STORAGEから認可情報を取得 */
    const authorityStorage = sessionStorage.getItem(AUTHORITY_STORAGE);
    var authorityStorageValue = JSON.parse(authorityStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const authCode = CFArrayFount(screenMaster,'path',location.pathname).auth;
    const authoritySubject = CFArrayFount(authorityStorageValue,'authMinCtgrCd',authCode)?.authSubCtgrCdList;
    if(authoritySubject?.find((item)=>item === id)){
        disabled = false;
    }else{
        disabled = true;
    }
    return disabled;
};

/* ====== フォーマットダウンロードボタン ====== */
export const ButtonIconFormatDownload = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'excelOutput')
    return (
        <IconOutlineButtonBase
            text='フォーマットダウンロード'
            type='button'
            onClick={onClick}            
            baloonPosition={'-55px'}    
            trianglePosition={'50%'}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${download}#download`}
            lockLeft={lockLeft}
        />

    )

};

/* ====== 一括登録ボタン ====== */
export const ButtonAllRegister = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'batchEdit')
    return (
        <IconButtonBase
            text='一括編集'
            type='button'
            onClick={onClick}
            baloonPosition={'-10px'}
            trianglePosition={'50%'}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${allRegister}#allRegister`}
        />
    )
};

/* ====== 新規登録ボタン ====== */
export const ButtonIconRegisterAuthRegister = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    const location = useLocation();
    let authorityControl = checkAuthority(location,'register')

    return (
        <IconButtonBase
            text='新規登録'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${newRegisterPlus}#newRegisterPlus`}
        />
    )
};

/* ====== 新規登録ボタン ====== */
export const ButtonIconRegisterAuthEdit = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    const location = useLocation();
    let authorityControl = checkAuthority(location,'edit')

    return (
        <IconButtonBase
            text='新規登録'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${newRegisterPlus}#newRegisterPlus`}
        />
    )
};

/* ====== 編集ボタン ====== */
export const IconButtonEdit = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'edit')
    return (
        <IconButtonBase
            id='edit'
            text='編集'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${pencil}#pencil`}
        />
    )
};

/* ====== 編集ボタン ====== */
export const ButtonEdit = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'edit')
    return (
        <ButtonBase
            text='編　集'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${pencil}#pencil`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== コピーして登録ボタン ====== */
export const ButtonIconCopyRegister = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'edit')
    return (
        <IconOutlineButtonBase
            text='コピーして登録'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${copyRegister}#copyRegister`}
            lockLeft={lockLeft}
        />

    )

};

/* ====== 削除ボタン ====== */
export const ButtonDelete = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'edit')
    return (
        <IconOutlineButtonBase
            text='削除'
            type='submit'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${Xmark}#Xmark`}
            lockLeft={lockLeft}
        />
    )
};

/* ====== 削除ボタン(文字) ====== */
export const ButtonDeleteLabel = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'edit')
    return (
        <ButtonRedOutline
            text='削　除'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${trashBox}#trashBox`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== 削除ボタン(ゴミ箱アイコン) ====== */
export const IconButtonDelete = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, baloonTopPosition, baloonPosition, trianglePosition, triangleTopPosition, lockLeft } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'edit')
    return (
        <IconOutlineButtonRed
            text='削除'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            baloonTopPosition={baloonTopPosition}
            baloonPosition={baloonPosition}
            trianglePosition={trianglePosition}
            triangleTopPosition={triangleTopPosition}
            xlinkHref={`${trashBox}#trashBox`}
            lockLeft={lockLeft}
        />
    )
};

/* ====== excel出力ボタン ====== */
export const ButtonExcel = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { style, onClick, disabled } = props; 
    const location = useLocation();
    const authorityControl = checkAuthority(location,'excelOutput')
    return (
        <ButtonBlueOutline
            id='excelOutput'
            text='Excel出力'
            style={style}
            type='submit'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            icon={
                <>
                    <SsvgIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                        <use xlinkHref={`${arrowLeft}#arrowLeft`}></use>
                    </SsvgIcon>
                </>
            } />
    )
};

/* ====== Excel出力アイコンボタン ====== */
export const ButtonIconExcel = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled, lockLeft } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'excelOutput')
    return (
        <IconOutlineButtonBase
            text='Excel出力'
            type='button'
            onClick={onClick}
            disabled={authorityControl ? authorityControl : disabled}
            xlinkHref={`${excel}#excel`}
            lockLeft={lockLeft}
        />
    )
};
/* ====== Excel出力アイコンボタン(テーブル用) ====== */
export const ButtonIconExcelTabel = (props) => {
    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { onClick, disabled } = props;
    const location = useLocation();
    const authorityControl = checkAuthority(location,'excelOutput')

    return (
        <SsvgIconButton 
            onClick={onClick} 
            color={ authorityControl ?  assets().color.disabled : disabled ?  assets().color.disabled :  assets().color.blue}
            className='svgStyle'
            disabled={authorityControl ? authorityControl : disabled} 
            style={{ height: assets().size.svgHeight, width: assets().size.svgWidth, }}>
            <use xlinkHref={`${excel}#excel`}></use>
        </SsvgIconButton>
    )
};
